import heroSwiper from "./heroSwiper";
import cookieBar from "./CookieBar";
import {cookiePreferencesButton} from "./cookiePreferencesButton";
import.meta.glob('../images/**/*');
// import 'swiper/css';
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

heroSwiper();
cookieBar();
cookiePreferencesButton('.js-cookie-preferences-button');
